import React from "react";
import lookappLogo from "../assets/lookapp.png";
import openmroLogo from "../assets/mro.png";
import guesthouseLogo from "../assets/lf.png";

const projects = [
  {
    name: "LookApp",
    logo: lookappLogo,
    description:
      "A smart spare parts & warehouse intelligence platform powered by AI + automation.",
    year: "2025",
  },
  {
    name: "OpenMRO",
    logo: openmroLogo,
    description:
      "An open-source MRO intelligence hub for enterprise-level supply chain transparency.",
    year: "2025",
  },
  {
    name: "Lumi",
    logo: null,
    description:
      "An intelligent assistant framework built on LLMs, powering enterprise decision-making and automation.",
    year: "2025",
  },
  {
    name: "Lou & Francis Guesthouse",
    logo: guesthouseLogo,
    description:
      "A modern, interactive guesthouse web app used as a design showcase and sample booking platform.",
    year: "2025",
  },
];

const Projects = () => {
  return (
    <section className="min-h-screen bg-[#f5f5f5] dark:bg-slate-900 py-20 px-6 font-[Inter]">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl md:text-5xl font-[DM Sans] font-bold mb-4 text-[#111] dark:text-white">
          Projects We're Building
        </h1>
        <p className="text-gray-600 dark:text-slate-300 text-lg mb-12 max-w-2xl mx-auto">
          These platforms represent our commitment to digital innovation, smart automation, and powerful user experiences — built by Blackbear Technologies Inc.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {projects.map((project, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-slate-800 p-6 rounded-xl border border-gray-200 dark:border-slate-700 shadow-sm hover:shadow-md hover:border-blue-700 dark:hover:border-blue-400 hover:-translate-y-1 transition-all duration-300 text-left"
            >
              {/* Logo or Name Block */}
              {project.logo ? (
                <div className="h-20 w-20 mx-auto flex items-center justify-center rounded-md bg-white dark:bg-slate-100 border border-slate-200 dark:border-slate-700 p-2 shadow mb-4 transition-colors">
                  <img
                    src={project.logo}
                    alt={`${project.name} logo`}
                    className="h-16 w-auto object-contain"
                  />
                </div>
              ) : (
                <div className="h-20 w-20 mx-auto flex items-center justify-center rounded-full bg-gradient-to-tr from-purple-500 to-indigo-600 shadow text-white font-[DM Sans] text-2xl font-bold mb-4">
                  L
                </div>
              )}

              <h2 className="text-lg font-semibold text-[#111] dark:text-white mb-2">
                {project.name}
              </h2>
              <p className="text-gray-600 dark:text-slate-300 text-sm leading-relaxed">
                {project.description}
              </p>
              <span className="text-xs text-gray-400 dark:text-slate-500 block mt-4">
                &copy; {project.year} Blackbear Technologies
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
